import PropTypes from 'prop-types';

import { Wrapper, Check, Label } from './Checkbox.style';

const Checkbox = ({ checkboxObj, checked, handleCheckboxClick }) => (
  <Wrapper onClick={() => handleCheckboxClick(checkboxObj.key)}>
    <Check checked={checked} />
    <Label>{checkboxObj.name}</Label>
  </Wrapper>
);

Checkbox.propTypes = {
  checkboxObj: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  checked: PropTypes.bool,
  handleCheckboxClick: PropTypes.func.isRequired,
};

Checkbox.defaultProps = {
  checked: false,
};

export default Checkbox;
